export default __webpack_public_path__ + "static/media/Right.f6d07bd7.svg";